import {
  ExternalAttributes, FilterAttributes, FilterAttributesModel,
} from 'components/discovery/shared/search/typing/filter-attributes.js'
import {
  FilterWizardConfig,
  filterWizardConfigSchema,
  FilterWizardFilters,
  filterWizardFiltersSchema
} from './typing/config.js'
import { z } from 'zod'
import typia, { IValidation } from 'typia'
import { logValidationFailure } from 'components/shared/parsing/parsing.js'
import IError = IValidation.IError;

const CouldNotParseConfig = 'CouldNotParseConfig' as const
const CouldNotParseAttributes = 'CouldNotParseAttributes' as const
const CouldNotParseFilters = 'CouldNotParseFilters' as const

type CouldNotParse = typeof CouldNotParseConfig | typeof CouldNotParseAttributes | typeof CouldNotParseFilters

export type FilterWizardConfigParseError = {
  type: CouldNotParse,
  error: IError[] | z.ZodError,
}

export type FilterWizardConfigParseResponse = {
  config: FilterWizardConfig,
  filters: FilterWizardFilters,
  attributes: FilterAttributes
}

export class FilterWizardParser {
  parseFilterWizardResponse = (response: unknown): FilterWizardConfigParseResponse | FilterWizardConfigParseError => {

    const config = filterWizardConfigSchema.safeParse(response)

    const filters = filterWizardFiltersSchema.safeParse(response)

    const attributes = typia.validate<ExternalAttributes>(response)

    if (config.error) {
      return { type: CouldNotParseConfig, error: config.error }
    }

    if (filters.error) {
      return { type: CouldNotParseFilters, error: filters.error }
    }

    if (!attributes.success) {
      logValidationFailure('filter wizard attributes', attributes.errors)
      return { type: CouldNotParseAttributes, error: attributes.errors }
    }

    return {
      config: config.data,
      filters: filters.data,
      attributes: new FilterAttributesModel().with(attributes.data).parse()
    }
  }

  configParseResultHasError = (
    parseResult: FilterWizardConfigParseResponse | FilterWizardConfigParseError
  ): parseResult is FilterWizardConfigParseError => {
    return (parseResult as FilterWizardConfigParseError).error != null
  }
}
